import './UploadeModal.scss';
import React, { useState } from 'react';
import Modal from '../modal/Modal';
import { useTranslation } from 'react-i18next';
import { FileInput } from '../fileInput/FileInput';
import AssetMetadata from '../assetMetadata/AssetMetadata';
import Server from '../../js/config/_server';
import { CLIENT_NAME } from '../../js/config/_global';
import { toCapitalizedString } from '../../js/helpers';
import { apiUpload } from '../../js/api';
import { generalStore } from '../../store';

const UploadeModal= ({
    onClose
}) => {
    const { t } = useTranslation();
    const { setAlert } = generalStore();
    const [assetIsDroped, setAssetIsDroped] = useState(false)
    const [fileBlob, setFileBlob] = useState<File>()
    const [isSetMetadataReady, setIsSetMetadataReady] = useState(false)
    const [uploadPayload, setUploadPayload] = useState<any>()
    const [isUploading, setIsUploading] = useState(false)

    const onUploadClick = async () => {
        setIsUploading(true)

        if (!fileBlob) {
            setIsUploading(false)
            return;
        }
        
        const formData = new FormData();

        formData.append('title', uploadPayload.title);
        formData.append('kvps', uploadPayload.kvps);
        formData.append('description', uploadPayload.description);
        formData.append('language', uploadPayload.language);
        formData.append('tags', uploadPayload.tags);
        formData.append('expirationDate', uploadPayload.expirationDate);
        formData.append('aiClassification', uploadPayload.aiClassification);
        formData.append('aiDisclosureRequired', uploadPayload.aiDisclosureRequired);
        formData.append('aiHumanReviewed', uploadPayload.aiHumanReviewed);

        formData.append('file', fileBlob);
   
        const url = Server.baseUrl + Server.services.dealerUpload.upload;

        apiUpload(url, formData).then(async() => {
            setIsUploading(false);
            setAlert({
                message: t('asset_upload_success'),
                type: 'info',
                display: true,
            });
            onClose();
        }).catch((error) => {
            console.error('Upload error:', error);
            setAlert({
                message: t('asset_upload_failed'),
                type: 'warning',
                display: true,
            });
            setIsUploading(false);
        });
    }

    return (
        <Modal
            show
            onClose={onClose}
            className='upload-modal'
            onAction={onUploadClick}
            onCancel={onClose}
            localeAction={t('upload')}
            isLoading={isUploading}
            disabled={!assetIsDroped || !isSetMetadataReady}
        >
            <Modal.Title>
                {t('upload_content_title')}:
                <br />
                <br />
                {t('upload_content_responsiblity', { brandName: toCapitalizedString(CLIENT_NAME) })}
                <br />
                <br />
                <p style={{fontWeight: "normal", fontSize: "10px"}}>* {t('upload_content_ai_hint')}</p>
            </Modal.Title>
            <Modal.Content>
                {!assetIsDroped 
                    ? <FileInput onAssetDroped={setAssetIsDroped} getFile={setFileBlob} />
                    : <AssetMetadata asset={null} editMode={false} assetBlob={fileBlob} checkIfReady={setIsSetMetadataReady} setPayload={setUploadPayload}/>
                }
            </Modal.Content>
        </Modal>
    )
}

export default UploadeModal
